import React, { useState } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { turkishBadWordsFilter } from '../../utils/turkishBadWordsFilter';

const ContactForm = ({ btnClass }) => {
    const [forms, setForms] = useState({
        from_name: '',
        from_email: '',
        message: '',
    });

    const [submitting, setSubmitting] = useState(false);
    const [, forceUpdate] = useState();

    const validator = new SimpleReactValidator({
        className: 'errorMessage',
        messages: {
            required: 'Bu alan zorunludur',
            email: 'Geçerli bir e-posta adresi giriniz',
            alpha_space: 'Sadece harf kullanabilirsiniz',
        },
    });

    const containsBadWords = (text) => {
        return turkishBadWordsFilter.isProfane(text);
    };

    const changeHandler = (e) => {
        const { name, value } = e.target;

        setForms({ ...forms, [name]: value });

        if ((name === 'from_name' || name === 'message') && containsBadWords(value)) {
            toast.warn('⚠️ Lütfen uygun bir dil kullanınız');
        }

        validator.showMessages();
        forceUpdate(1);
    };

    const submitHandler = (e) => {
        e.preventDefault();

        if (
            containsBadWords(forms.from_name) ||
            containsBadWords(forms.message)
        ) {
            toast.error('Mesajınız uygunsuz ifadeler içeriyor ❌');
            return;
        }

        if (!validator.allValid()) {
            validator.showMessages();
            toast.error('Lütfen formdaki hataları düzeltin');
            forceUpdate(1);
            return;
        }

        setSubmitting(true);

        emailjs
            .send(
                'service_v1speps',
                'template_0g9mzdb',
                {
                    from_name: forms.from_name,
                    from_email: forms.from_email,
                    message: forms.message,
                    date: new Date().toLocaleString('tr-TR'),
                },
                'mGMhA-ORZZH_MUjSn'
            )
            .then(() => {
                toast.success('Mesajınız başarıyla gönderildi!');
                setForms({
                    from_name: '',
                    from_email: '',
                    message: '',
                });
                validator.hideMessages();
            })
            .catch(() => {
                toast.error('Mesaj gönderilirken bir hata oluştu');
            })
            .finally(() => {
                setSubmitting(false);
            });
    };

    return (
        <div className="wpo-contact-form-area">

            <ToastContainer
                position="top-right"
                autoClose={4000}
                hideProgressBar={false}
                pauseOnHover
                draggable
            />

            <form onSubmit={submitHandler}>
                <div className="row">

                    <div className="col-md-6 col-12">
                        <div className="form-field">
                            <input
                                type="text"
                                name="from_name"
                                value={forms.from_name}
                                onChange={changeHandler}
                                className="form-control"
                                placeholder="İsim Soyisim*"
                                disabled={submitting}
                            />
                            {validator.message(
                                'from_name',
                                forms.from_name,
                                'required|alpha_space'
                            )}
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="form-field">
                            <input
                                type="email"
                                name="from_email"
                                value={forms.from_email}
                                onChange={changeHandler}
                                className="form-control"
                                placeholder="E-posta Adresi*"
                                disabled={submitting}
                            />
                            {validator.message(
                                'from_email',
                                forms.from_email,
                                'required|email'
                            )}
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="form-field">
                            <textarea
                                name="message"
                                value={forms.message}
                                onChange={changeHandler}
                                className="form-control"
                                placeholder="Mesajınız*"
                                disabled={submitting}
                            />
                            {validator.message(
                                'message',
                                forms.message,
                                'required'
                            )}
                        </div>
                    </div>

                </div>

                <div className="submit-area">
                    <button
                        type="submit"
                        className={btnClass}
                        disabled={submitting}
                    >
                        <span>
                            {submitting ? 'Gönderiliyor...' : 'Mesaj Gönder'}
                        </span>
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ContactForm;
